import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import LazyLoadSelect from "../../components/LazyLoadSelect";
import React from "react";
import { Select } from "antd";
const DebtorSelect = ({ disabled = false, allowClear = false, value, placeholder = "Select a Debtor", onChange, onDebtorSelected }) => {
    const optionsRenderer = (debtors) => {
        return debtors.map(it => {
            return _jsxs(Select.Option, { value: it.id, filter: `${it.name} ${it.contactName}`, children: [it.name, " - ", it.contactName] }, it.id);
        });
    };
    return (_jsx(LazyLoadSelect, { url: "/admin/v1/debtors", searchKey: "nameLike", placeholder: placeholder, queryParams: {
            enabled: true
        }, disabled: disabled, allowClear: allowClear, value: value, onChange: onChange, onSelected: onDebtorSelected, optionsRenderer: optionsRenderer }));
};
export default DebtorSelect;
